import React, { useEffect } from 'react';
import { Typography, Button, FormControl } from '@mui/material';
import FormControlError from '~/_base/components/formControlError';
import { useForm } from 'react-hook-form';

const optional = process.env['E2E'] || process.env.NODE_ENV === 'development';

interface ConfirmHumanProps {
  onSubmit: (data: { recaptcha_code_v2: string }) => Promise<void>;
  onPrevious: () => void;
}

export default function ConfirmHuman({
  onPrevious,
  onSubmit,
}: ConfirmHumanProps) {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm<{ recaptcha_code_v2: string }>();
  const trialSetupEl = document.getElementById('react-trial-setup');
  const sitekey = trialSetupEl?.getAttribute('data-recaptcha-v2-sitekey') ?? '';

  useEffect(() => {
    (window as any).grecaptcha.render('samm_recaptcha', {
      sitekey,
    });
    register('recaptcha_code_v2', { required: !optional });
  }, [register, sitekey]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h1" style={{ marginBottom: 24 }}>
        We need to check you're a human
      </Typography>
      <FormControl
        variant="standard"
        required
        fullWidth
        error={errors.recaptcha_code_v2 != null}
        style={{ marginBottom: 16 }}>
        {errors.recaptcha_code_v2 && (
          <FormControlError message="Please complete the Captcha below" />
        )}
        <div
          style={{ marginBottom: 16 }}
          id="samm_recaptcha"
          data-sitekey={sitekey}
        />
      </FormControl>
      <div
        style={{
          marginTop: 16,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button variant="contained" style={{ width: 120 }} onClick={onPrevious}>
          Previous
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ width: 120 }}
          onClick={() =>
            setValue('recaptcha_code_v2', (window as any).grecaptcha.getResponse())
          }
        >
          Submit
        </Button>
      </div>
    </form>
  );
}
